import React from 'react';
import { Box } from '@mui/material';

export type RegulatoryFrameworkId =
  | 'epd'
  | 'dppEspr'
  | 'scope3Upstream'
  | 'productCarbonFootprint';

type RegulatoryFrameworkOption = {
  id: RegulatoryFrameworkId;
  value: string;
  tagLabel: string;
};

export const REGULATORY_FRAMEWORK_OPTIONS: RegulatoryFrameworkOption[] = [
  {
    id: 'epd',
    value: 'Environmental Product Declaration (EPD)',
    tagLabel: 'EPD',
  },
  {
    id: 'dppEspr',
    value: 'Digital Product Passport (DPP - ESPR)',
    tagLabel: 'DPP - ESPR',
  },
  {
    id: 'productCarbonFootprint',
    value: 'Product Carbon Footprint (ISO 14067)',
    tagLabel: 'ISO 14067',
  },
  {
    id: 'scope3Upstream',
    value: 'Scope 3 Upstream',
    tagLabel: 'Scope 3 Upstream',
  },
];

export const REQUIRED_FRAMEWORKS_BY_EXCEL_ROW: Record<
  number,
  RegulatoryFrameworkId[]
> = {
  3: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  4: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  5: ['epd'],
  6: ['epd'],
  7: ['epd'],
  10: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  11: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  12: ['epd'],
  13: ['epd', 'productCarbonFootprint'],
  14: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  15: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  16: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  19: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  20: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  22: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  23: ['dppEspr'],
  31: ['dppEspr'],
  32: ['dppEspr', 'epd'],
  33: ['dppEspr', 'epd', 'productCarbonFootprint'],
  34: ['dppEspr', 'epd', 'productCarbonFootprint'],
  35: ['dppEspr', 'productCarbonFootprint'],
  36: ['epd'],
  37: ['epd', 'scope3Upstream', 'productCarbonFootprint'],
  38: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  39: ['epd'],
  40: ['epd'],
  41: ['epd'],
  42: ['epd'],
  43: ['epd'],
  44: ['epd'],
  45: ['epd'],
  46: ['epd'],
  47: ['epd'],
  50: ['dppEspr', 'scope3Upstream', 'productCarbonFootprint'],
  51: ['dppEspr'],
  52: ['dppEspr'],
  53: ['dppEspr'],
  54: ['dppEspr'],
  55: ['dppEspr'],
  56: ['dppEspr'],
  57: ['dppEspr', 'epd'],
  58: ['dppEspr'],
  59: ['dppEspr'],
  60: ['dppEspr'],
  61: ['dppEspr'],
  62: ['dppEspr', 'scope3Upstream', 'productCarbonFootprint'],
  63: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  64: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  65: ['dppEspr'],
  66: ['dppEspr'],
  67: ['dppEspr', 'scope3Upstream', 'productCarbonFootprint'],
  68: ['dppEspr'],
  69: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  70: ['dppEspr'],
  71: ['dppEspr'],
  72: ['dppEspr'],
  73: ['dppEspr'],
  74: ['dppEspr'],
  75: ['dppEspr'],
  76: ['dppEspr'],
  78: ['dppEspr'],
  79: ['dppEspr'],
  80: ['dppEspr'],
  81: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  82: ['dppEspr'],
  83: ['dppEspr'],
  84: ['dppEspr'],
  85: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  86: ['dppEspr'],
  87: ['dppEspr', 'scope3Upstream', 'productCarbonFootprint'],
  89: ['dppEspr'],
  91: ['dppEspr'],
  92: ['dppEspr', 'epd'],
  93: ['dppEspr'],
  94: ['dppEspr'],
  95: ['dppEspr'],
  96: ['dppEspr'],
  97: ['dppEspr'],
  98: ['dppEspr'],
  99: ['dppEspr'],
  100: ['dppEspr'],
  101: ['dppEspr'],
  102: ['dppEspr'],
  107: ['epd'],
  109: ['epd'],
  110: ['epd'],
  111: ['epd'],
  112: ['epd'],
  120: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  121: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  122: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  123: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  124: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  125: ['dppEspr'],
  126: ['dppEspr'],
  127: ['dppEspr'],
  128: ['dppEspr', 'epd', 'productCarbonFootprint'],
  129: ['dppEspr'],
  130: ['dppEspr', 'epd'],
  131: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  132: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  133: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  134: ['epd', 'scope3Upstream', 'productCarbonFootprint'],
  135: ['epd', 'scope3Upstream', 'productCarbonFootprint'],
  136: ['epd', 'scope3Upstream', 'productCarbonFootprint'],
  137: ['dppEspr'],
  138: ['dppEspr'],
  139: ['dppEspr'],
  140: ['dppEspr'],
  141: ['dppEspr'],
  142: ['dppEspr'],
  143: ['dppEspr'],
  144: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  145: ['dppEspr', 'scope3Upstream', 'productCarbonFootprint'],
  146: ['dppEspr', 'scope3Upstream', 'productCarbonFootprint'],
  147: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  148: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  149: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  150: ['dppEspr', 'scope3Upstream', 'productCarbonFootprint'],
  151: ['dppEspr'],
  152: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  153: ['dppEspr', 'epd'],
  154: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  155: ['dppEspr', 'epd', 'scope3Upstream', 'productCarbonFootprint'],
  156: ['dppEspr'],
  157: ['epd'],
  158: ['epd'],
  159: ['epd'],
  160: ['epd'],
  161: ['epd'],
};

export const EXCEL_ROW_BY_FIELD_NAME: Partial<Record<string, number>> = {
  key_company_activities: 13,
  production_country: 14,
  production_location: 15,
  distribution_regions: 16,
  gtin_code: 17,
  gpc_code: 18,
  product_type: 19,
  actual_product_use_information: 20,
  production_date: 22,
  warranty_period_conditions: 23,
  ce_mark: 24,
  development_flowcharts_description: 25,
  'attachment: development-flowchart': 26,
  technical_documentation_description: 27,
  'attachment: technical-documentation': 28,
  related_documents_description: 29,
  'attachment: related-documents': 30,
  image_id: 31,
  product_category_rules: 32,
  expected_product_lifetime_years: 50,
  repairability_information: 51,
  availability_of_spare_parts: 52,
  compatibility_with_commonly_available_tools_and_spare_parts: 53,
  repair_disassembly_instructions_description: 54,
  'attachment: repair-disassembly-instructions': 55,
  proper_use_instructions: 56,
  'attachment: proper-use-instructions': 57,
  delivery_time_of_spare_parts: 58,
  affordability_of_spare_parts: 59,
  mean_time_between_failures: 60,
  resistance_to_stress_or_aging_mechanisms: 61,
  guaranteed_service_life: 62,
  operating_life: 63,
  number_and_complexity_of_repair_processes: 65,
  need_for_specialised_tools: 66,
  conditions_for_access_to_product_data: 67,
  conditions_for_access_to_required_equipment_and_software: 68,
  functional_performance_of_product: 69,
  compatibility_with_other_products_or_systems: 70,
  required_user_skills: 71,
  access_to_testing_protocols_or_specialised_testing_equipment: 72,
  warranty_availability_for_refurbished_or_remanufactured_products: 73,
  access_conditions_to_intellectual_property_protected_technologies: 74,
  recycling_possibilities: 75,
  disassembly_instructions: 76,
  'attachment: disassembly-instructions': 77,
  epr_information_description: 78,
  disposal_instructions: 79,
  safe_easy_non_destructive_access_to_recyclable_components_materials_or_components_containing_hazardous_substances: 80,
  material_composition_and_material_homogeneity: 81,
  ability_to_sort_materials_while_maintaining_high_purity: 82,
  ease_of_non_destructive_disassembly_and_reassembly: 83,
  avoidance_of_technical_design_solutions_that_hinder_reuse_upgrade_repair_maintenance_refurbishment_remanufacturing_or_recycling_of_products_and_components: 84,
  hazardous_substances_level: 85,
  recommended_fire_extinguishing_agents: 86,
  safety_labels_and_symbols: 87,
  'attachment: safety-labels-symbols': 88,
  safe_use_instructions: 89,
  'attachment: safe-use-instructions': 90,
  use_of_substances_of_concern_during_manufacturing_process: 91,
  presence_of_substances_of_concern_in_product_as_substances_mixtures_or_components: 92,
  presence_of_substances_of_concern_when_product_becomes_waste: 93,
  impact_of_substances_of_concern_on_human_health_and_environment: 94,
  amount_of_consumables_required_for_proper_operation_and_maintenance: 95,
  characteristics_of_consumables: 96,
  availability_of_consumables: 97,
  performance_efficiency_of_consumables: 98,
  technical_lifetime_of_consumables: 99,
  reusability_of_consumables: 100,
  repairability_of_consumables: 101,
  remanufacturability_regenerability_of_consumables: 102,
  functional_unit: 120,
  data_collection_period: 121,
  weight: 123,
  weight_unit: 124,
  dimensions_unit: 128,
  volume: 129,
  volume_unit: 130,
  product_carbon_footprint: 144,
  emissions_to_air_water_soil_noise: 145,
  microplastics_nanoplastics_release: 146,
  energy_water_resource_consumption: 147,
  primary_energy_use: 148,
  recovered_exported_energy: 149,
  product_performance_factors_impact: 150,
  deforestation_impact: 151,
  recycled_materials_share: 152,
  material_recovery_critical_raw_materials: 153,
  renewable_materials_content: 154,
  waste_generated: 155,
  co2_sequestration_potential: 157,
  ozone_depletion_potential: 158,
  acidification_potential: 159,
  eutrophication_potential: 160,
  photochemical_ozone_creation_potential: 161,
};

export const parseRegulatoryFrameworks = (
  rawValue: string
): RegulatoryFrameworkId[] => {
  if (!rawValue) {
    return [];
  }

  const tokens = rawValue
    .split('|')
    .flatMap((chunk) => chunk.split(','))
    .flatMap((chunk) => chunk.split('\n'))
    .map((chunk) => chunk.trim())
    .filter(Boolean);

  return REGULATORY_FRAMEWORK_OPTIONS.filter((option) =>
    tokens.includes(option.value)
  ).map((option) => option.id);
};

export const serializeRegulatoryFrameworks = (
  frameworkIds: RegulatoryFrameworkId[]
) =>
  REGULATORY_FRAMEWORK_OPTIONS.filter((option) =>
    frameworkIds.includes(option.id)
  )
    .map((option) => option.value)
    .join(' | ');

const getSelectedRequiredFrameworks = (
  excelRow: number,
  regulatoryFrameworks: string
) => {
  const selectedFrameworks = parseRegulatoryFrameworks(regulatoryFrameworks);
  const requiredFrameworks = REQUIRED_FRAMEWORKS_BY_EXCEL_ROW[excelRow] || [];

  return requiredFrameworks
    .filter((frameworkId) => selectedFrameworks.includes(frameworkId))
    .map((frameworkId) =>
      REGULATORY_FRAMEWORK_OPTIONS.find((option) => option.id === frameworkId)
    )
    .filter((option): option is RegulatoryFrameworkOption => !!option);
};

type WrapperLayoutStyle = Pick<
  React.CSSProperties,
  | 'flex'
  | 'flexGrow'
  | 'flexShrink'
  | 'flexBasis'
  | 'minWidth'
  | 'maxWidth'
  | 'width'
  | 'alignSelf'
>;

const getWrapperLayoutStyle = (children: React.ReactNode) => {
  if (React.Children.count(children) !== 1) {
    return {};
  }

  const child = React.Children.only(children);
  if (!React.isValidElement(child)) {
    return {};
  }

  const childStyle = (child.props as { style?: React.CSSProperties }).style;
  const wrapperStyle: Partial<WrapperLayoutStyle> = {
    ...(typeof childStyle?.flex !== 'undefined'
      ? { flex: childStyle.flex }
      : {}),
    ...(typeof childStyle?.flexGrow !== 'undefined'
      ? { flexGrow: childStyle.flexGrow }
      : {}),
    ...(typeof childStyle?.flexShrink !== 'undefined'
      ? { flexShrink: childStyle.flexShrink }
      : {}),
    ...(typeof childStyle?.flexBasis !== 'undefined'
      ? { flexBasis: childStyle.flexBasis }
      : {}),
    ...(typeof childStyle?.minWidth !== 'undefined'
      ? { minWidth: childStyle.minWidth }
      : {}),
    ...(typeof childStyle?.maxWidth !== 'undefined'
      ? { maxWidth: childStyle.maxWidth }
      : {}),
    ...(typeof childStyle?.width !== 'undefined'
      ? { width: childStyle.width }
      : {}),
    ...(typeof childStyle?.alignSelf !== 'undefined'
      ? { alignSelf: childStyle.alignSelf }
      : {}),
  };

  const childProps = child.props as { fullWidth?: boolean };
  if (
    childProps.fullWidth &&
    typeof wrapperStyle.width === 'undefined' &&
    typeof wrapperStyle.flex === 'undefined' &&
    typeof wrapperStyle.flexGrow === 'undefined'
  ) {
    wrapperStyle.width = '100%';
  }

  return wrapperStyle;
};

export function ComplianceField({
  excelRow,
  regulatoryFrameworks,
  children,
}: Readonly<{
  excelRow?: number;
  regulatoryFrameworks?: string;
  children: React.ReactNode;
}>) {
  if (!excelRow || !regulatoryFrameworks) {
    return <Box sx={{ display: 'contents' }}>{children}</Box>;
  }

  const tags = getSelectedRequiredFrameworks(excelRow, regulatoryFrameworks);
  if (tags.length === 0) {
    return <Box sx={{ display: 'contents' }}>{children}</Box>;
  }

  const wrapperLayoutStyle = getWrapperLayoutStyle(children);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
      style={wrapperLayoutStyle}
    >
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {tags.map((tag) => (
          <Box
            component="span"
            key={tag.id}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              borderRadius: '999px',
              px: '8px',
              py: '2px',
              backgroundColor: '#fff1e3',
              border: '1px solid #e7c5a1',
              color: '#7e4308',
              fontSize: '11px',
              fontWeight: 700,
              lineHeight: '16px',
              letterSpacing: '0.02em',
              textTransform: 'uppercase',
            }}
          >
            {tag.tagLabel}
          </Box>
        ))}
      </Box>
      {children}
    </Box>
  );
}
